// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2uEUK","logo":"Header_logo__1VQNg"};